//video onload on platforms page
(function ($) {
    $(function () {
        if (sectionId === 5540) {
            const vendorCss = "/static/css/page-5540.css",
                vendorScript = "/static/vendors/page-5540.js";

            /***upload platforms vendors***/
            $.ajaxPrefilter(function (options) {
                options.async = true;
                options.cache = true;
            });

            $("head").append(
                $("<link>").attr({
                    rel: "stylesheet",
                    href: vendorCss,
                    type: "text/css",
                })
            );

            $("body").append($(`<script src=${vendorScript}></script>`));

            $.getScript(vendorScript, function () {
                AOS.init({
                    duration: 1000,
                });
            });

            const emulateAnchorElementClick = (href) => {
                const targetElement = $('.platforms-list').children().children(`a[href="${href}"]`);
                setTimeout(()=>targetElement.click(), 3500);
            }

            let hash = $(location).prop('hash').substr(1);
            switch (hash) {
                case "JForex":
                    emulateAnchorElementClick("#anchor-desktop")
                    break;
                case "Web":
                    emulateAnchorElementClick("#anchor-web")
                    break;
                case "iOS":
                    emulateAnchorElementClick("#anchor-mobile")
                    break;
                case "Android":
                    emulateAnchorElementClick("#anchor-mobile")
                    break;
                case "MT4Platform":
                    emulateAnchorElementClick("#anchor-metatrader")
                    break;
            }

            /***videos management on page***/
            $window.on("load", function () {
                $("video").each(function () {
                    var $this = $(this),
                        src = $this.data("src");
                    if (src) {
                        if (window.devicePixelRatio > 1) {
                            src += "@2x";
                        }
                    }
                });

                if (winWidth >= cssBreakPoints["md"]) {
                    //on tablets and mobiles works by other logic
                    $.each($(".platforms-video"), function () {
                        //load videos only on screens > 992px
                        let mediaData1 = $(this).data("video-src1"),
                            mediaData2 = $(this).data("video-src2"),
                            mediaData3 = $(this).data("video-src3");
                        let content = `<source src="${mediaData1}"
                                   type="video/webm"
                                   media="only screen and (min-device-pixel-ratio: 1.5)">
                                   <source src="${mediaData2}"
                                   type="video/webm">
                                   <source src="${mediaData3}"
                                   type="video/mp4">
                                   <p>Sorry, your browser
                                   doesn't support
                                   embedded
                                   videos.</p>`;
                        $(this).append(content);
                    });

                    $(".video-features-block .child-item").on({
                        "mouseenter.tp-video-features": function () {
                            // var $this = $(this),
                            //     $video = $this.find('video');
                            // $video.get(0).play();
                            proceedVideoFeatures.call(this);
                        },
                        "mouseleave.tp-video-features": function () {
                            // var $this = $(this),
                            //     $video = $this.find('video');
                            // $video.get(0).pause();
                            proceedVideoFeatures.call(this);
                        },
                        "touchend.tp-video-features": function () {
                            proceedVideoFeatures.call(this);
                        },
                    });
                } else {
                    $(".video-features-block--desktop .child-item").each(function () {
                        $(this).addClass("active");
                    });
                }

                function proceedVideoFeatures() {
                    var $this = $(this),
                        $parent = $this.parents(".video-features-block"),
                        $active = $parent.find(".active"),
                        $activeVideo = $active.find("video"),
                        $video = $this.find("video");

                    $active.removeClass("active");
                    // $activeVideo.each(function () {
                    //     //each - for both themes videos
                    //     // this.pause();
                    // });

                    if ($this.hasClass("active")) {
                        // $video.each(function () {
                        //     //each - for both themes videos
                        //     // this.pause();
                        // });
                        $this.removeClass("active");
                    } else {
                        $this.addClass("active");
                        // $video.each(function () {
                        //     //each - for both themes videos
                        //     this.play();
                        // });
                    }
                }
            });
        }
    });
})(jQuery);
